<template>

<footer class="footer">
  <div class="container">

    <div class="columns">

      <div class="column has-text-left contacts">
        <p class="title is-5 has-text-link">
          Контакти
        </p>

        <p><strong>0700 11 7 55</strong> национален номер</p>
        <p><small>02/ 962 96 90</small> телефон</p>
        <p><small>02/ 962 76 63</small> факс</p>
        <p><a href="mailto:sofiacomm@gmail.com">sofiacomm@gmail.com</a></p>
        <p>София, жк. Дианабад, ул. Васил Калчев, бл. 58, офис&nbsp;6</p>

      </div>

      <!-- <div class="column has-text-left contacts">
        <p class="title is-5 has-text-link">
          Лични данни
        </p>
      </div> -->

      <div class="column is-6 has-text-left">
        <p class="title is-5 has-text-link">
          Обща информация
        </p>

        <!-- <p><a href="http://www.creditgroup.cc/sccg/privacy.php">Поверителност</a></p> -->
        <!-- <p><a href="http://www.creditgroup.cc/sccg/faq.php">Въпроси</a></p> -->

        <p>
          <router-link to="/cookie-policy">Политика за бисквитки</router-link>
        </p>

        <p>
          <router-link tag="a" to="/general-terms">
            Общи условия за предоставяне на кредити за недвижии имоти на потребители
          </router-link>
        </p>

        <p>
          <router-link tag="a" to="/general-info">
            Обща информация за кредити за недвижими имоти на потребители
          </router-link>
        </p>

        <h6 class="">Помощ при решаване на потребителски спорове:</h6>

        <p>
          Сайт на Платформата ОРС:
          <a
            href="https://ec.europa.eu/consumers/odr/main/index.cfm?event=main.home2.show&lng=BG"
          >

            <span class="">https://ec.europa.eu/consumers/odr/main/index.cfm?event=main.home2.show&lng=BG</span>
          </a>
        </p>

        <p>
          Сайт на Комисия за защита на потребителите:
          <a
            href="https://kzp.bg/"
          >
            <br>
            <span class="text-gray-500">https://kzp.bg/</span>
          </a>
        </p>

      </div>

      <div class="column is-3 has-text-left">

        <p class="title is-5 has-text-link">
          Карта на сайта
        </p>

        <p><a @click.prevent="$eventBus.scrollTo('navbar')">Начало</a></p>
        <p><a @click.prevent="$eventBus.scrollTo('products')">Кредити</a></p>
        <p><a @click.prevent="$eventBus.scrollTo('p-plans')">План</a></p>
        <p><a @click.prevent="$eventBus.scrollTo('application-form')">Заявка за кредит</a></p>
        <p><a @click.prevent="$eventBus.scrollTo('about')">За нас</a></p>
        <p><a @click.prevent="$eventBus.scrollTo('footer')">Контакт</a></p>

      </div>

    </div>

    <div class="text-center">
      <small class="copyright">© 2006–{{ '2018' }} София Комерс Кредит Груп АД. Всички права запазени.</small>
    </div>

  </div>
</footer>

</template>

<script>
export default {
  name: 'Footer',
  data () {
    return {
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="stylus" scoped>

</style>



// WEBPACK FOOTER //
// src/components/Footer.vue